import { CreatorLifecycleState } from './creator-lifecycle';
import { CreatorGrowthLoop, createEmptyCreatorGrowthLoop } from './creator-growth-loop';
import { CreatorScoreModel, createEmptyCreatorScoreModel } from './creator-score.model';
import { FeedImpactModel, FEED_IMPACT_MODEL } from './feed-impact.model';
import { CreatorGraphSignals } from '../graph/creator-graph-signals';

/**
 * Unified creator economy loop — connects identity, feed, graph, monetization, and events.
 * Conceptual container only; no orchestration logic.
 */
export interface CreatorEconomyLoop {
  lifecycleState: CreatorLifecycleState;
  growthLoop: CreatorGrowthLoop;
  scores: CreatorScoreModel;
  feedImpact: FeedImpactModel;
  graphSignals: CreatorGraphSignals | null;
}

export interface CreatorEconomyLoopSnapshot {
  lifecycleState: CreatorLifecycleState;
  growthLoop: CreatorGrowthLoop;
  scores: CreatorScoreModel;
}

export function createEmptyCreatorEconomyLoop(
  lifecycleState: CreatorLifecycleState = CreatorLifecycleState.VISITOR,
): CreatorEconomyLoop {
  return {
    lifecycleState,
    growthLoop: createEmptyCreatorGrowthLoop(),
    scores: createEmptyCreatorScoreModel(),
    feedImpact: FEED_IMPACT_MODEL,
    graphSignals: null,
  };
}

/** Describes how subsystems connect within the loop (documentation-as-types). */
export const CREATOR_ECONOMY_LOOP_CONNECTIONS = {
  identity: 'PlatformIdentity evolves through CreatorLifecycleState',
  feed: 'FeedImpactModel maps exposure → engagement, follows, earnings',
  graph: 'CreatorGraphSignals receive follow and engagement weight from events',
  monetization: 'CreatorEarnings linked via purchase_completed event mapping',
  events: 'DomainEventType mappings drive growth loop inputs and score dimensions',
} as const;
